// Mobile store links. Set `url` to the real store page once published: the badge becomes a download button.
export const MOBILE_APPS = {
  android: { url: null, store: 'Google Play', comingSoon: 'Bientôt sur Google Play' },
  ios: { url: null, store: "l'App Store", comingSoon: "Bientôt sur l'App Store" },
};

// Real interface captures (public/app-screens). Replace the files to update the visuals.
export const APP_SCREENS = {
  desktop: '/app-screens/desktop-create.jpg',
  androidPhone: '/app-screens/mobile-home.jpg',
  // Official Android captures (already framed in a realistic phone) for the mobile section.
  androidHome: '/app-screens/android-home.webp',
  androidCreate: '/app-screens/android-create.webp',
};
